/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ContentListEntryFromJSON, ContentListEntryToJSON, } from './ContentListEntry';
import { DateRangeFromJSON, DateRangeToJSON, } from './DateRange';
import { MetaDataFromJSON, MetaDataToJSON, } from './MetaData';
import { NamedResourceTagFromJSON, NamedResourceTagToJSON, } from './NamedResourceTag';
import { PlayerListEntryFromJSON, PlayerListEntryToJSON, } from './PlayerListEntry';
import { TimeRangeOfDayFromJSON, TimeRangeOfDayToJSON, } from './TimeRangeOfDay';
/**
 * Check if a given object implements the CampaignResponse interface.
 */
export function instanceOfCampaignResponse(value) {
    var isInstance = true;
    isInstance = isInstance && "active" in value;
    return isInstance;
}
export function CampaignResponseFromJSON(json) {
    return CampaignResponseFromJSONTyped(json, false);
}
export function CampaignResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'tags': !exists(json, 'tags') ? undefined : (json['tags'].map(NamedResourceTagFromJSON)),
        'organisationId': !exists(json, 'organisationId') ? undefined : json['organisationId'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'duration': !exists(json, 'duration') ? undefined : DateRangeFromJSON(json['duration']),
        'active': json['active'],
        'contents': !exists(json, 'contents') ? undefined : (json['contents'].map(ContentListEntryFromJSON)),
        'timePlan': !exists(json, 'timePlan') ? undefined : (json['timePlan'].map(TimeRangeOfDayFromJSON)),
        'targetPlayers': !exists(json, 'targetPlayers') ? undefined : (json['targetPlayers'].map(PlayerListEntryFromJSON))
    };
}
export function CampaignResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'name': value.name,
        'metaData': MetaDataToJSON(value.metaData),
        'tags': value.tags === undefined ? undefined : (value.tags.map(NamedResourceTagToJSON)),
        'organisationId': value.organisationId,
        'userId': value.userId,
        'duration': DateRangeToJSON(value.duration),
        'active': value.active,
        'contents': value.contents === undefined ? undefined : (value.contents.map(ContentListEntryToJSON)),
        'timePlan': value.timePlan === undefined ? undefined : (value.timePlan.map(TimeRangeOfDayToJSON)),
        'targetPlayers': value.targetPlayers === undefined ? undefined : (value.targetPlayers.map(PlayerListEntryToJSON))
    };
}
